import React from 'react';

function EventsPage() {
  return <div><h2>Events</h2></div>;
}

export default EventsPage;
